/* eslint-disable prettier/prettier */
import * as gql from 'fake-tag';

export const BannerFragment = {
  Banner: gql`
    fragment BannerQuery on promoBanner_Entry {
      overwriteCoupon
      promotionEndsDateTime
      promotionReset {
        ... on promotionResetBlock_Entry {
          promotionEndsDateTime
          resetText {
            html
          }
        }
      }
      promotionStartDateTime
      promotionText
      showHidePromoBanner
    }
  `,
};
